<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <vendedor-form
            v-show="isModalVisible"
            @close="closeModal"
            :afterCreateAction="loadList"
            :action="vendedorAction"
            :code="vendedorCode"
          ></vendedor-form>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
    <template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <card
                class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
              >
                <template slot="header">
                  <div class="float-left">
                    <h4 class="card-title">Vendedores Cadastrados</h4>
                  </div>
                  <div class="float-right">
                    <button
                      type="submit"
                      class="btn btn-success btn-fill"
                      @click="novoVendedor"
                    >
                      Novo
                    </button>
                  </div>
                </template>
                <l-table
                  class="table-hover table-striped"
                  :columns="tabelaVendedores.columns"
                  :data="tabelaVendedores.data"
                >
                  <template slot-scope="{ row }">
                    <td>
                      <b>{{ row.name }}</b>
                    </td>
                    <td>
                      <button
                        class="btn btn-icon btn-info"
                        style="margin-right: 10px"
                        @click="editarVendedor(row)"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        class="btn btn-icon btn-danger"
                        @click="handleDelete(row)"
                      >
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </td>
                  </template>
                </l-table>
                <template slot="footer">
                  <v-pagination
                    v-if="tabelaVendedores.data.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                  ></v-pagination>
                </template>
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- DELETE MODAL -->
    <div v-show="isDeleteModalVisible" @close="closeModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Deseja realmente excluir o vendedor?</strong>
                </h5>
              </div>
              <div class="modal-body">
                Esta ação é definitiva e não poderá ser desfeita.
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click.prevent
                  @click="closeDeleteModal()"
                >
                  Fechar
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click.prevent
                  @click="deleteVendedor()"
                >
                  Deletar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import VendedorForm from './Formulario.vue';
import LTable from 'src/components/Table.vue';
import VendedoresServices from 'src/services/vendedores';
import vPagination from 'vue-plain-pagination';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['Nome'];
export default {
  components: {
    VendedorForm,
    LTable,
    vPagination
  },
  data() {
    return {
      tabelaVendedores: {
        columns: [...tableColumns],
        data: []
      },
      isModalVisible: false,
      vendedorAction: '',
      vendedor: {},
      vendedorCode: undefined,
      isDeleteModalVisible: false,
      vendedorParaDeletar: {},
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      }
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      VendedoresServices.listar({ page: this.currentPage })
        .then(response => {
          this.tabelaVendedores.data = _.get(response, 'data.result');
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            icon: 'fa fa-exclamation-triangle'
          });
        });
    },
    novoVendedor() {
      this.vendedorAction = 'NEW';
      this.vendedorCode = undefined;
      this.isModalVisible = true;
    },
    editarVendedor(vendedor) {
      this.vendedorAction = 'EDIT';
      this.vendedorCode = vendedor.code;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    handleDelete(row) {
      this.isDeleteModalVisible = true;
      this.vendedorParaDeletar = row;
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.vendedorParaDeletar = {};
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    deleteVendedor() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Deletado com Sucesso.',
          'fa fa-check'
        );
        this.loadList();
        this.closeDeleteModal();
        loader.hide();
      };

      const errorCallback = err => {
        this.notifyVue(
          'top',
          'center',
          'danger',
          err,
          'fa fa-exclamation-triangle'
        );
        this.closeDeleteModal();
        loader.hide();
      };

      VendedoresServices.deletar(this.vendedorParaDeletar)
        .then(sucessCallback)
        .catch(errorCallback);
    },
    parseDate(date) {
      const year = date.slice(0, 4);
      const month = date.slice(5, 7);
      const day = date.slice(8, 10);
      return `${day}/${month}/${year}`;
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    }
  }
};
</script>
<style scope>
.pagination {
  justify-content: center;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
}
</style>
